import React from 'react';

import http from 'api/http';
import { trailerAPI } from 'api/requests';

import { APPLICATION_MODE } from 'constants/trailer';
import { STATUS } from 'constants/index';
import { HASH, ACTION, LINK } from 'constants/routing';
import { ROLES } from 'constants/roles';

import List from './List';
import Application from './Application';
import Store from '../../../registerIDBWorker';

const defaultSelectedTrailer = {
  id: '',
  name: '',
  year: '',
  emptyTrailerWeight: '',
  over80Wide: false,
  couplerRatingWithBrakes: '',
  couplerRatingWithoutBrakes: '',
  strapRating: '',
  hookRating: '',
  winchRating: '',
  numberOfAxles: '',
  grossAxleWeightRating: '',
  grossVehicleWeightRating: '',
  maxLoadCapacity: '',
  status: ''
};

class TrailerManufacturer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      trailerList: [],
      selectedTrailer: {...defaultSelectedTrailer},
      applicationMode: APPLICATION_MODE.CLOSED,
      listRequestInProcess: true
    };
  }

  roleSwitch = () => {
    const {user} = this.props;
    if (user.getActiveRole() !== ROLES.TRAILER_MANUFACTURER.serverName) {
      user.changeMenu(ROLES.TRAILER_MANUFACTURER.serverName);
    }
  };

  componentDidMount() {
    const {user} = this.props;

    this.roleSwitch();

    this._loadFromStore();

    http.get(trailerAPI.trailers)
      .then(({data: trailerList}) => {
        Store.insert(`${user.getActiveRole()}_lists`, trailerList, user.getManufacturerCode())
          .then(() => {
            this._loadFromStore(() => {
              this.setState({listRequestInProcess: false}, () => {
                const __isEditMode = () => {
                  const {hash} = this.props.location;

                  return hash.indexOf(HASH.EDIT) !== -1;
                };

                const __getIdFromHash = () => {
                  const {hash} = this.props.location;

                  return hash.split('edit=')[1].split('?')[0];
                };

                if (__isEditMode()) {
                  let selectedTrailer = this.state.trailerList.find(trailer => +trailer.id === +__getIdFromHash());

                  if (!selectedTrailer) selectedTrailer = {...defaultSelectedTrailer};

                  if (!this.state.selectedTrailer || +selectedTrailer.id !== +this.state.selectedTrailer.id) {
                    this.setState({selectedTrailer});
                  }
                }
              });
            });
          });
      });
  }

  componentDidUpdate() {
    this._toggleApplication();
  }

  _loadFromStore = (cb = () => {}) => {
    const {user} = this.props;

    Store.select(`${user.getActiveRole()}_lists`, user.getManufacturerCode())
      .then(trailerList => {
        this.setState({trailerList}, cb);
      });
  };

  _toggleApplication = () => {
    const {action} = this.props.history;

    let applicationMode = APPLICATION_MODE.CLOSED;

    switch (action) {
      case ACTION.POP:
        applicationMode = this._togglePOPAction();
        break;
      case ACTION.PUSH:
      case ACTION.REPLACE:
        applicationMode = this._togglePRAction();
        break;
      default:
        break;
    }

    if (applicationMode) {
      this.setState({applicationMode});
    }
  };

  _togglePOPAction = () => {
    const {applicationMode} = this.state;

    if (this._hashHasApplicationState()) {
      if (applicationMode !== APPLICATION_MODE.OPENED) {
        return APPLICATION_MODE.OPENED;
      } else {
        return null;
      }
    } else {
      if (applicationMode !== APPLICATION_MODE.CLOSED) {
        return APPLICATION_MODE.CLOSED;
      } else {
        return null;
      }
    }
  };

  _togglePRAction = () => {
    const {applicationMode} = this.state;

    if (this._hashHasApplicationState()) {
      if (applicationMode !== APPLICATION_MODE.OPENED && applicationMode !== APPLICATION_MODE.OPENING) {
        return APPLICATION_MODE.OPENING;
      } else {
        return null;
      }
    } else {
      if (applicationMode !== APPLICATION_MODE.CLOSED && applicationMode !== APPLICATION_MODE.CLOSING) {
        return APPLICATION_MODE.CLOSING;
      } else {
        return null;
      }
    }
  };

  _hashHasApplicationState = () => {
    const {hash} = this.props.location;

    return hash.indexOf(HASH.ADD) !== -1 || hash.indexOf(HASH.EDIT) !== -1;
  };

  updateLocationState = (link, hash) => () => {
    const {history, location, user} = this.props;

    const prevLink = location.pathname + location.hash;
    if (prevLink !== link + hash) {
      history.replace(`/${user.getManufacturerCode()}/${link}${location.search}${hash}`);
    }
  };

  handleInputChange = type => value => {
    if (type !== 'name') {
      if (type !== 'couplerRatingWithBrakes' && type !== 'couplerRatingWithoutBrakes') {
        value = this._removeZero(value);
      }

      if (value[0] === '0') value = (+value).toString();
    }

    this.setState(prevState => {
      return {
        selectedTrailer: {
          ...prevState.selectedTrailer,
          [type]: value
        }
      };
    });
  };

  _removeZero = value => {
    return +value === 0 ? '' : value;
  };

  handleCheckboxChange = () => {
    this.setState(prevState => {
      return {
        selectedTrailer: {
          ...prevState.selectedTrailer,
          over80Wide: !prevState.selectedTrailer.over80Wide
        }
      };
    });
  };

  updateList = newTrailer => {
    const {trailerList} = this.state;

    let index = trailerList.findIndex(trailer => {
      return +trailer.id === +newTrailer.id;
    });

    const state = {trailerList: [...trailerList]};

    if (index !== -1) {
      if (newTrailer.status === null) {
        state.trailerList.splice(index, 1);
        state.selectedTrailer = {...defaultSelectedTrailer};
        this.selectTrailer(null)();
      } else if (newTrailer.status === STATUS.DEACTIVATED) {
        state.trailerList[index] = newTrailer;
        state.selectedTrailer = {...defaultSelectedTrailer};
        this.selectTrailer(null)();
      } else if (newTrailer.isRollOver) {
        state.trailerList.push(newTrailer);
      } else {
        state.trailerList[index] = newTrailer;
        state.selectedTrailer = newTrailer;
      }
    } else {
      state.trailerList.unshift(newTrailer);
      state.selectedTrailer = {...defaultSelectedTrailer};
    }

    this.setState(state);
  };

  selectTrailer = selectedTrailer => () => {
    this.setState({selectedTrailer: selectedTrailer || defaultSelectedTrailer}, () => {
      if (selectedTrailer === null) {
        this.updateLocationState(`${LINK.LIST.TRAILER}`, '')();
      } else {
        this.updateLocationState(`${LINK.LIST.TRAILER}`, `#edit=${selectedTrailer.id}`)();
      }
    });
  };

  calcRightMarginForApplication = () => {
    let marginRight = 135;
    const section = document.getElementsByClassName('ect-section')[0];
    const root = document.getElementsByClassName('ect-root')[0];
    if (section && root) {
      if (section.clientHeight > root.clientHeight) {
        if (/chrome/i.test(navigator.userAgent)) {
          marginRight = 150;
        }
        if (/firefox/i.test(navigator.userAgent)) {
          marginRight = 148;
        }
      }
    }

    return marginRight;
  };

  render() {
    const {applicationMode, selectedTrailer, trailerList, listRequestInProcess} = this.state;
    const {history, location, user} = this.props;

    return (
      <React.Fragment>
        <section className='ect-section _position_relative'>
          <List
            list={trailerList}
            updateLocationState={this.updateLocationState}
            updateList={this.updateList}
            selectTrailer={this.selectTrailer}
            listRequestInProcess={listRequestInProcess}
            user={user}
          />
        </section>
        <Application
          applicationMode={applicationMode}
          marginRight={this.calcRightMarginForApplication()}
          updateList={this.updateList}
          updateLocationState={this.updateLocationState}
          selectedTrailer={selectedTrailer}
          selectTrailer={this.selectTrailer}
          handleInputChange={this.handleInputChange}
          handleCheckboxChange={this.handleCheckboxChange}
          user={user}
          history={history}
          location={location}
        />
      </React.Fragment>
    );
  }
}

export default TrailerManufacturer;



// WEBPACK FOOTER //
// ./src/app/Scenes/TrailerManufacturer/index.jsx